"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All user related translations
var User = {
  which_activities_mail: {
    nl: 'Van welke activiteiten wil jij een mail ontvangen?',
    fr: 'De quelles activités souhaitez-vous recevoir un e-mail?',
    en: 'From which activities do you want to receive an email?',
    de: 'Von welchen Aktivitäten möchten Sie eine E-Mail erhalten?'
  },
  team_graphic_activities: {
    nl: 'Activiteiten van het grafische team',
    fr: 'Activités de l\'équipe graphique',
    en: 'Activities of the graphic team',
    de: 'Aktivitäten des Grafikteams'
  },
  team_developers_activities: {
    nl: 'Activiteiten van het developers team',
    fr: 'Activités de l\'équipe de développeurs',
    en: 'Activities of the developers team',
    de: 'Aktivitäten des Entwicklerteams'
  },
  team_sales_activities: {
    nl: 'Activiteiten van het sales team',
    fr: 'Activités de l\'équipe commerciale',
    en: 'Activities of the sales team',
    de: 'Aktivitäten des Verkaufsteams'
  },
  basically_who_you_are: {
    nl: 'Dit is wie je bent.',
    fr: 'C\'est qui vous êtes.',
    en: 'This is basically who you are.',
    de: 'Das ist im Wesentlichen, wer Sie sind.'
  },
  change_or_remove_avatar: {
    nl: 'Wijzig of verwijder hier uw avatar.',
    fr: 'Modifiez ou supprimez votre avatar ici.',
    en: 'Change or remove your avatar here.',
    de: 'Ändern oder entfernen Sie hier Ihr Avatar.'
  },
  registration_successful: {
    nl: 'Registratie succesvol',
    fr: 'Inscription réussie',
    en: 'Registration successful',
    de: 'Registrierung erfolgreich'
  },
  registration_failed: {
    nl: 'Registratie mislukt',
    fr: 'Inscription échouée',
    en: 'Registration unsuccessful',
    de: 'Registrierung fehlgeschlagen'
  },
  username_already_in_use: {
    nl: 'Gebruikersnaam is al in gebruik',
    fr: 'Nom d\'utilisateur déjà utilisé',
    en: 'Username already in use',
    de: 'Benutzername bereits vergeben'
  },
  username_check_failed: {
    nl: 'Gebruikersnaam controle mislukt',
    fr: 'Contrôle du nom d\'utilisateur échoué',
    en: 'Username check failed',
    de: 'Benutzername überprüfung fehlgeschlagen'
  },
  please_enter_first_name: {
    nl: 'Geef eerste naam',
    fr: 'Entrez votre prénom',
    en: 'Please enter your first name',
    de: 'Bitte geben Sie Ihren Vornamen ein'
  },
  please_enter_last_name: {
    nl: 'Geef achternaam',
    fr: 'Entrez votre nom',
    en: 'Please enter your last name',
    de: 'Bitte geben Sie Ihren Nachnamen ein'
  },
  ACTIEVE_GEMEENTEN: {
    nl: 'ACTIEVE GEMEENTEN',
    fr: 'COMMUNES ACTIVES',
    en: 'ACTIEVE GEMEENTEN',
    de: 'ACTIEVE GEMEENTEN'
  },
  who_i_follow: {
    nl: 'WIE VOLG IK?',
    fr: 'MES SUIVIS',
    en: 'Who I follow',
    de: 'Wer ich folge'
  },
  active_gemeenten_tooltip: {
    nl: 'Bekijk de interactieve kaart met actieve gemeenten.',
    fr: 'Voir la carte interactive avec les communes actives.',
    en: 'Active municipalities',
    de: 'Aktive Gemeinden'
  },
  who_i_follow_tooltip: {
    nl: 'Bekijk en beheer de gemeenten die je volgt.',
    fr: 'Voir et gérer les communes que vous suivez.',
    en: 'Who you follow',
    de: 'Wer Sie folgen'
  }
};
var _default = User;
exports["default"] = _default;